import React from "react";
import styled from "styled-components";
import IconSvg from "~/guidelines/Icon/IconSvg";
import { body2 } from "~/guidelines/Typography";

const Container = styled.div`
  display: flex;
  align-items: center;
  ${body2};
  padding: 8px 16px;
  border-radius: 50px;
  background-color: ${({ theme }) => theme.color.background.lightFirst};
  color: ${({ theme }) => theme.color.text.lightThird};

  & > ${IconSvg} {
    color: ${({ theme }) => theme.color.text.lightFirst};
    margin-right: 8px;
  }
`;

export type InformationPillProps = {
  icon: React.ReactNode;
  text: string;
};

const InformationPill = ({ icon, text }: InformationPillProps) => {
  return (
    <Container>
      {icon}
      {text}
    </Container>
  );
};

export default InformationPill;
